const fileOptions = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];

function fileType(fileType: string): boolean {
  if (!fileType) {
    return false;
  }

  const fileVerified = fileOptions.includes(fileType, 0);

  return fileVerified;
}

export default fileType;
